import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=308d18c8"
import script from "./Editor.ts?vue&type=script&lang=js&external"
export * from "./Editor.ts?vue&type=script&lang=js&external"
import style0 from "./Editor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports